import React from 'react';

import styles from "../../../styles/athlete-widget.placeholder.module.scss"
import classNames from "classnames";
import {AthleteWidgetIconPlaceholder} from "./athlete-widget.icon.placeholder";

export const AthleteWidgetIconsMobilePlaceholder = ({device}) => {
  const {isSmallView} = device;

  const entityProps = {
    device,
    iconSize: 24,
  }

  return (
    <div className={classNames(styles.icons, {[styles.small_view]: isSmallView})}>
      <AthleteWidgetIconPlaceholder {...entityProps}/>
      <div className={classNames(styles.vertical_divider)}/>
      <AthleteWidgetIconPlaceholder {...entityProps}/>
      <div className={classNames(styles.vertical_divider)}/>
      <AthleteWidgetIconPlaceholder {...entityProps}/>
    </div>
  )
}
